import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Money: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M4.01 22.52c6.8 0 13.4.91 19.67 2.62.32.09.62-.16.62-.46v-1.24a.92.92 0 1 1 1.84 0v1.24a2.33 2.33 0 0 1-2.95 2.24 72.94 72.94 0 0 0-19.18-2.55.92.92 0 1 1 0-1.85ZM26.61 5a2.3 2.3 0 0 1 2.3 2.3v12a2.3 2.3 0 0 1-2.3 2.3H5.4a2.3 2.3 0 0 1-2.31-2.3v-12A2.3 2.3 0 0 1 5.39 5H26.6ZM6.77 6.84c0 1.02-.83 1.85-1.85 1.85v9.22c1.02 0 1.85.83 1.85 1.84h18.44c0-1.01.83-1.84 1.85-1.84V8.69a1.84 1.84 0 0 1-1.85-1.85H6.78Zm11.99 6.46a2.77 2.77 0 1 0-5.54 0 2.77 2.77 0 0 0 5.54 0Zm-10.14-.92a.92.92 0 0 1 0 1.85.92.92 0 0 1-.93-.92v-.01c0-.51.41-.92.92-.92h.01Zm14.76 0a.92.92 0 0 1 0 1.85h-.01a.92.92 0 0 1-.92-.92v-.01c0-.51.4-.92.92-.92Zm-2.78.92a4.61 4.61 0 1 1-9.22 0 4.61 4.61 0 0 1 9.22 0Z"
    />
  </Icon>
);
